import { HeartHandshake, ClipboardCheck, CalendarCheck2 } from "lucide-react";

const CARDS = [
  {
    icon: HeartHandshake,
    title: "A calm, stress-free test day",
    body: "Julie comes to your home or your co-op, so your child tests somewhere familiar. Her warm, patient approach helps children settle in and do their best work.",
  },
  {
    icon: ClipboardCheck,
    title: "Results you can use",
    body: "TerraNova results show where your child is thriving and where to focus next, with a clear explanation from Julie to help you plan the year ahead.",
  },
  {
    icon: CalendarCheck2,
    title: "Easy online booking",
    body: "Choose a date that suits your family and pay online in minutes. Book any time of year; spring dates fill fastest.",
  },
];

export default function WhyFamilies() {
  return (
    <section data-testid="why-families-section" className="bg-[#FFF9E6]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <h2 className="text-3xl md:text-4xl text-[#1A243B] leading-snug max-w-2xl mb-6">
          Homeschool testing that feels like <span className="italic">support</span>, not scrutiny
        </h2>
        <p className="text-base md:text-lg text-[#2D3748] leading-relaxed max-w-2xl mb-12">
          Homeschooling is a rewarding journey, but you shouldn't have to work out testing on your own. Julie has homeschooled her own family, so she knows what you're balancing and makes testing one less thing to worry about.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {CARDS.map((c, i) => (
            <div key={c.title} data-testid={`why-card-${i}`} className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <span className="w-12 h-12 rounded-full bg-[#FFC107] flex items-center justify-center mb-6">
                <c.icon className="w-5 h-5 text-[#1A243B]" />
              </span>
              <h3 className="font-display text-xl text-[#1A243B] mb-3">{c.title}</h3>
              <p className="text-[#2D3748] text-base leading-relaxed">{c.body}</p>
            </div>
          ))}
        </div>
        <a data-testid="why-book-btn" href="#book" className="cta-pill inline-block bg-[#FFC107] text-[#1A243B] font-bold px-8 py-3.5 rounded-full">
          Book a testing date →
        </a>
      </div>
    </section>
  );
}
